<template>
	<div class="container">
		<div class="row">
			<div class="col-12 btn-group">
				<button @click="showModalFile = true" class="btn btn-primary">
					{{ 'Upload' | translate }}
				</button>
				<button @click="showModalFolder = true" class="btn btn-success">
					{{ 'Create folder' | translate }}
				</button>
			</div>
			<div v-if="folder" class="col-xl-3 col-lg-4 col-sm-6 col-12">
				<div
					class="folder"
					@click="
						loadFiles('back')
						loadFolder('back')
					"
				>
					<span><i class="fa fa-arrow-circle-left" aria-hidden="true"/></span>
					<h3>{{ 'Back' | translate }}</h3>
				</div>
			</div>
			<div
				v-for="(folder, i) in folders"
				:key="folder.id"
				class="col-xl-3 col-lg-4 col-sm-6 col-12 block"
			>
				<div class="delete" @click="remove(folder.id, 'folders', i)">
					<i class="fa fa-trash" aria-hidden="true" />
				</div>
				<div
					class="folder"
					@click="
						loadFolder(folder.id, folder.parent)
						loadFiles(folder.id)
					"
				>
					<span><i class="fa fa-folder" aria-hidden="true"/></span>
					<h3 class="file-name">{{ folder.name | longName }}</h3>
				</div>
			</div>
			<div
				v-for="(file, i) in files"
				:key="file.id"
				class="col-xl-3 col-lg-4 col-sm-6 col-12 block"
			>
				<div class="delete" @click="remove(file.id, 'files', i)">
					<i class="fa fa-trash" aria-hidden="true" />
				</div>
				<div class="folder file">
					<span><i class="fa fa-file-o" aria-hidden="true"/></span>
					<h3>
						<a
							class="file-name"
							@click.prevent="download(file.link, file.name)"
							href=""
							>{{ file.name | longName }}</a
						>
					</h3>
				</div>
			</div>
		</div>
		<ModalFolder :show="showModalFolder" @close="showModalFolder = false" />
		<ModalFile :show="showModalFile" @close="showModalFile = false" />
	</div>
</template>

<script>
import ModalFolder from './Modal/Folder.vue'
import ModalFile from './Modal/File.vue'

export default {
	name: 'storage',
	data: () => ({
		showModalFolder: false,
		showModalFile: false,
	}),
	components: {
		ModalFolder,
		ModalFile,
	},
	computed: {
		storage() {
			return this.$store.state.storage
		},
		folders() {
			return this.storage.folders
		},
		files() {
			return this.storage.files
		},
		folder() {
			// Param `folder` can be either null and 0, that mean ROOT folder, or any number (id)
			return this.storage.folder
		},
		history() {
			return this.storage.history
		},
	},
	filters: {
		longName(name) {
			if (!name) return ''
			return name.length < 35
				? name
				: `${name.slice(0, 20)}...${name.slice(-7, -1)}`
		},
	},
	methods: {
		loadFolder(id, parent = null) {
			// `Parent` -- mean from where we come: Root (null/0) or any nested folder
			// If id is `back` => load folders from latest folder in history
			// If latest folder is null => load from user`s root folder
			// Clean folder list
			this.$store.commit('changeStorageFolders', [])
			let folder = ''
			if (id === 'back') {
				const lastInHistory = this.history[this.history.length - 1]
				if (lastInHistory) folder = `?folder=${lastInHistory}`
				this.$store.commit('changeStorageHistory')
				this.$store.commit('changeStorageFolder', lastInHistory || parent)
			} else if (typeof id === 'number') {
				folder = `?folder=${id}`
				this.$store.commit('changeStorageHistory', parent)
				this.$store.commit('changeStorageFolder', id)
			}

			this.axios({
				method: 'get',
				url: `storage/folders/${folder}`,
			}).then(response =>
				this.$store.commit('changeStorageFolders', response.data)
			)
		},
		loadFiles(id) {
			// If id is `back` => load files from latest folder in history
			// If last folder from history is `null` => load from user`s root folder
			// Clean file list
			this.$store.commit('changeStorageFiles', [])
			let folder = ''
			if (id === 'back') {
				const lastInHistory = this.history[this.history.length - 1]
				folder = !lastInHistory ? '' : `?folder=${lastInHistory}`
			} else if (typeof id === 'number') {
				folder = `?folder=${id}`
			}

			this.axios({
				method: 'get',
				url: `storage/files/${folder}`,
			}).then(response =>
				this.$store.commit('changeStorageFiles', response.data)
			)
		},
		remove(id, type, index) {
			this.axios({
				method: 'delete',
				url: `storage/${type}/${id}/`,
			}).then(response => {
				this.$store.commit('removeStorageData', { type, index })
			})
		},
		download(link, name) {
			this.axios({
				url: link,
				method: 'GET',
				responseType: 'blob',
			}).then(response => {
				const link = document.createElement('a')
				link.href = window.URL.createObjectURL(new Blob([response.data]))
				link.setAttribute('download', name)
				document.body.appendChild(link)
				link.click()
			})
		},
	},
	created() {
		this.loadFolder()
		this.loadFiles()
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.folder {
	height: 200px;
	border: 2px solid #78909c;
	margin: 20px 0;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.folder span {
	font-size: 85px;
}

.delete {
	opacity: 0;
	position: absolute;
	font-size: 30px;
	padding: 5px;
	right: 20px;
	top: 20px;
	transition: 0.3s;
	cursor: pointer;
	color: #333;
}

.block:hover .delete {
	opacity: 1;
}

.file-name {
	font-size: 18px;
	display: flex;
	flex: 1;
	justify-content: center;
	text-align: center;
	word-wrap: break-word;
	word-break: break-all;
}
</style>
